export default {
    validateProject(project){
        if(project.name.length <1){
            this.$toasted.error("Project name required!")
            return false;
        }
        return true;
    }
}